<template>
  <div class="device-chart-block" style="min-height: 250px">
    <div class="device-chart-title">
      <div v-if="adminTool == false" class="cropperiod-info">
        {{ cropperiod_name }}
      </div>
      <div class="device-chart-info">
        <h4 class="header-sub device-name">
          <i :class="$tools.style.classIcon(device.type, 'block-title')"></i
          >{{ device.nickname }}
          <span class="block-text device-hashid">{{ device.hashid }}</span>
          <span v-if="user_admin" class="block-text device-deviceid"
            >( Device ID = {{ device.deviceid }} )</span
          >
        </h4>
      </div>
      <div v-if="autoUpdate" class="device-chart-info">
        <!-- 最後一筆資料時間 -->
        <div v-if="deviceData && deviceData.time" class="update-time">
          <!-- 最後一筆時間 -->
          <div v-if="deviceData.time.length > 0" class="block-text">
            <i class="fa fa-refresh block-text"></i>{{ $t("menu.updated") }}:
            {{ deviceData.time[deviceData.time.length - 1] }}
          </div>

          <!-- 自動更新頻率 -->
          <!-- <div v-if="user_admin || $tools.service.check_ShowUI_byRole(this.project_role, 'update_frequency')" class="admin-info">
                        <i class="fa fa-gift block-text"></i>
                        {{ $t('menu.update_frequency') }}： {{ $t('menu.per') }} {{ autoUpdateMinutes }} {{ $t('u.minutes') }}
                    </div> -->
        </div>
      </div>

      <div v-if="autoUpdate == false" class="device-chart-info">
        <!-- 資料說明 -->
        <div v-if="deviceData && deviceData.time" class="update-time">
          <div class="admin-info">
            <!-- 觀測時間 -->
            <div v-if="deviceData.time.length > 0" class="block-text">
              <i class="fa fa-clock-o"></i>{{ $t("menu.observe_time") }}:
              {{ deviceData.time[0] }} ~
              {{ deviceData.time[deviceData.time.length - 1] }}
            </div>

            <!-- 資料筆數 -->
            <div class="block-text">
              <i class="icon-lock icons"></i>{{ $t("menu.data_count") }}：{{
                deviceData.time.length
              }}
              / {{ importQuery_DataCount }} ( {{ importQuery_Range }}
              {{ importQuery_Unit }} )
            </div>
          </div>
        </div>
      </div>

      <!-- 阿龜資料讀取畫面 -->
      <div v-if="loading_showInfo">
        <AgriLoading :showCloud="true" :showAgriGift="true"></AgriLoading>
      </div>
    </div>
    <div
      v-if="autoUpdate == false && device.description"
      class="device-chart-info device-chart-description"
    >
      {{ device.description }}
    </div>

    <!-- <div v-if="user_admin == true && device.note">
      <b-alert variant="secondary" show>
        <div class="block-text-sm">
          <i class="icon-menu"></i>{{ $t("menu.admin_note") }}：
        </div>
        <div v-html="device.note" class="block-sm"></div>
      </b-alert>
    </div> -->

    <!-- Lazyloading - Detect View Area -->
    <lazy-component @show="lazy_handler(device)"></lazy-component>

    <b-row class="device-chart-list" v-if="deviceData">
      <template v-for="(ds, idx_ds) in drawDeviceSensorItems">
        <b-col
          :key="idx_ds"
          class="device-chart-col"
          cols="12"
          sm="12"
          :md="renderColumn(ds, 'md')"
          :lg="renderColumn(ds, 'lg')"
          :xl="renderColumn(ds, 'xl')"
        >
          <LineChart
            v-if="renderChart(ds, 'LineChart')"
            :chartID="
              'device-sensor-chart-' + device.hashid + '-line-' + idx_ds
            "
            :sensorCode="ds"
            :time="deviceData.time"
            :data="deviceData[ds]"
            :info_type="info_type"
            :standard="sensor_rules[ds]"
            :showToolbox="showToolbox"
            :xAxisName="'time'"
          ></LineChart>

          <BarChart
            v-if="renderChart(ds, 'BarChart')"
            :chartID="'device-sensor-chart-' + device.hashid + '-bar-' + idx_ds"
            :sensorCode="ds"
            :time="deviceData.time"
            :data="deviceData[ds]"
            :info_type="info_type"
            :standard="sensor_rules[ds]"
            :showToolbox="showToolbox"
            :xAxisName="'time'"
          ></BarChart>

          <WindChart
            v-if="renderChart(ds, 'WindChart')"
            :chartID="
              'device-sensor-chart-' + device.hashid + '-wind-' + idx_ds
            "
            :time="deviceData.time"
            :dataList="deviceData"
            :info_type="info_type"
            :standard="sensor_rules[ds]"
            :showToolbox="showToolbox"
            :xAxisName="'time'"
          ></WindChart>

          <LineChartWindSpeed
            v-if="renderChart(ds, 'LineChartWindSpeed')"
            :chartID="
              'device-sensor-chart-' +
              device.hashid +
              '-line-wind-speed-' +
              idx_ds
            "
            :sensorCode="ds"
            :time="deviceData.time"
            :data="deviceData[ds]"
            :info_type="info_type"
            :standard="sensor_rules[ds]"
            :showToolbox="showToolbox"
            :xAxisName="'time'"
          ></LineChartWindSpeed>
        </b-col>
      </template>
    </b-row>
  </div>
</template>


<script>
import { mapState } from "vuex";
import AgriLoading from "@/views/components/AgriLoading";

import LineChart from "@/views/echarts/LineChart";
import BarChart from "@/views/echarts/BarChart";
import WindChart from "@/views/echarts/WindChart";
import LineChartWindSpeed from "@/views/echarts/LineChart_WindSpeed ";

export default {
  props: {
    adminTool: {
      type: Boolean,
      required: false,
    },
    device: {
      type: Object,
      required: true,
    },
    info_type: {
      type: String,
      default: "realtime",
    },
    timezone: {
      type: String,
      required: true,
    },
    cropperiod_uuid: {
      type: [String, Number],
      required: true,
    },
    cropperiod_name: {
      type: String,
    },
    sensor_rules: {
      type: Object,
      default: {},
    },
    autoUpdate: {
      type: Boolean,
      default: true,
    },
    importData: {
      type: Object,
      default: undefined,
    },
    importQuery_Range: {
      type: Number,
      default: 0,
    },
    importQuery_Unit: {
      type: String,
      default: "",
    },
    importQuery_DataCount: {
      type: Number,
      default: 0,
    },
    showToolbox: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    AgriLoading,
    LineChart,
    BarChart,
    WindChart,
    LineChartWindSpeed,
  },
  data() {
    return {
      sizeColumn: {
        default: {
          sm: 12,
          md: 6,
          lg: 4,
          xl: 4,
        },
        big: {
          sm: 12,
          md: 12,
          lg: 12,
          xl: 12,
        },
      },
      deviceData: undefined,
      queryRange: 1,
      timer: "",
      autoUpdateMinutes: 1 * 60, // 一小時更新一次
      loading_showInfo: false,
    };
  },
  created() {
    if (this.autoUpdate) {
      let _intervalTime = this.autoUpdateMinutes * 60 * 1000;
      this.timer = setInterval(this.updateDeviceData, _intervalTime);
    }
  },
  mounted() {},
  computed: {
    ...mapState({
      user_admin: (state) => state.user.is_admin,
    }),

    // 取得裝置的前兩碼
    deviceVersion() {
      if (this.device.hashid)
        return this.device.hashid[0] + this.device.hashid[1];
      return "";
    },

    showDeviceSensorItems() {
      return this.device.visualization;
    },

    drawDeviceSensorItems() {
      let original_order = []; // 依照原本的參數設定順序排列
      let last_order = []; // 放在最後的參數
      let sensorItems = this.showDeviceSensorItems;

      sensorItems.forEach((item) => {
        // 判斷有 [ 電壓 ] 就自動抽換成 [ 電量百分比 ]
        if (this.renderChart(item) == false) {
        } // Do Nothing
        else if (item == "voltage") {
          last_order.push("voltage_to_battery_percentage");
        } else if (item == "battery_percentage") {
          last_order.push(item);
        } else if (item == "snr") {
          last_order.push(item);
        } else if (item == "rssi") {
          last_order.push("rssi_to_signal_bar");
        } else if (item == "lqi") {
          last_order.push("lqi_to_signal_bar");
        } else {
          original_order.push(item);
        }
      });

      last_order.forEach((item) => {
        original_order.push(item);
      });
      sensorItems = original_order;

      return sensorItems;
    },
  },
  watch: {
    // 偵測到 [ 固定匯入資料 ] 變動就更新圖表
    importData() {
      this.deviceData = this.importData;
    },
  },
  methods: {
    initial_Query() {
      // WD 因為每小時只有一筆，故最少 query range 為 6 小時
      if (this.deviceVersion == "WD") this.queryRange = 6;
      else this.queryRange = 1;

      if (this.importData) {
        this.deviceData = this.importData;
      } else {
        this.updateDeviceData();
      }
      // this.deviceData.voltage_to_battery_percentage = this.$tools.ui.getVoltageToPercentage(this.deviceData.voltage);
      // console.log( this.deviceData.voltage_to_battery_percentage )
    },

    lazy_handler(device) {
      // console.log( device.hashid + ' show data !' )
      this.initial_Query();
    },

    setQueryRange(range) {
      this.queryRange = range;
      this.updateDeviceData();
    },
    activeQueryRage(range) {
      if (this.queryRange == range) return true;
      return false;
    },

    updateDeviceData() {
      this.loading_showInfo = true;

      let _query = "?params=" + this.showDeviceSensorItems.join(",");

      const options = {
        method: "GET",
        url:
          this.$config.getAPI_URL("Cropperiod_Public_Device_Realtime", {
            cropperiodUUID: this.cropperiod_uuid,
            deviceID: this.device.hashid,
          }) + _query,
      };
      this.$http(options)
        .then((res) => {
          this.loading_showInfo = false;

          let _deviceData = res.data[this.device.hashid];
          _deviceData.time = this.$tools.date.dateTimeZone_List(
            _deviceData.time,
            this.timezone,
            "YYYY-MM-DD HH:mm"
          );

          // 將 WD 小於等於 -99 的數值轉為 null
          let _deviceVersion = this.device.hashid[0] + this.device.hashid[1];
          if (_deviceVersion == "WD") {
            for (let key_param in _deviceData) {
              if (key_param != "time") {
                for (let i = 0; i < _deviceData[key_param].length; i++) {
                  if (_deviceData[key_param][i] <= -99) {
                    _deviceData[key_param][i] = null;
                  }
                }
              }
            }
          }

          // 判斷有 [ 電壓 ] 資料就自動轉成 [ 電量百分比 ]，並儲存在 voltage_to_battery_percentage 內
          if (_deviceData.voltage && _deviceData.voltage.length > 0) {
            _deviceData.voltage_to_battery_percentage =
              this.$tools.ui.getVoltageToPercentage(_deviceData.voltage);
          }
          // 判斷有 [ 訊號強度 ] 資料就自動轉成 [ 手機訊號格數 ]，並儲存在 rssi_to_signal_bar 內
          if (_deviceData.rssi && _deviceData.rssi.length > 0) {
            _deviceData.rssi_to_signal_bar = this.$tools.ui.getRssiToSignalBar(
              _deviceData.rssi
            );
          }
          // 判斷有 [ 訊號品質指標 ] 資料就自動轉成 [ 訊號格數 ]，並儲存在 lqi_to_signal_bar 內
          if (_deviceData.lqi && _deviceData.lqi.length > 0) {
            _deviceData.lqi_to_signal_bar = this.$tools.ui.getLQIToSignalBar(
              _deviceData.lqi
            );
          }

          this.deviceData = _deviceData;
        })
        .catch((err) => {
          this.loading_showInfo = false;
        });
    },

    checkChartType(chartCode, renderComponent) {
      if (chartCode == "col") return true;
      return chartCode == renderComponent;
    },
    /**
     * renderChart 用來設定該感測器參數要畫哪種圖
     * @param {string} sesorItem - 感測器參數代碼
     * @param {string} [chartCode='col'] - 當下判斷到的 chart 元件，預設為 col 表示只是用來判斷該感測器是否要進行繪製
     */
    renderChart(sensorItem, chartCode = "col") {
      switch (sensorItem) {
        case "air_temperature":
          return this.checkChartType(chartCode, "LineChart");
        case "air_humidity":
          return this.checkChartType(chartCode, "LineChart");
        case "air_temperature02":
          return this.checkChartType(chartCode, "LineChart");
        case "air_humidity02":
          return this.checkChartType(chartCode, "LineChart");

        case "air_co2_temperature":
          return this.checkChartType(chartCode, "LineChart");
        case "air_co2_humidity":
          return this.checkChartType(chartCode, "LineChart");

        case "air_co":
          return this.checkChartType(chartCode, "BarChart");
        case "air_co2":
          return this.checkChartType(chartCode, "BarChart");
        case "air_nh3":
          return this.checkChartType(chartCode, "BarChart");

        case "air_pm25":
          return this.checkChartType(chartCode, "BarChart");
        case "air_pm10":
          return this.checkChartType(chartCode, "BarChart");
        case "air_pressure":
          return this.checkChartType(chartCode, "LineChart");

        case "wind_speed":
          if (this.device.hashid[0].toLowerCase() == "w")
            return this.checkChartType(chartCode, "WindChart");
          else return this.checkChartType(chartCode, "LineChartWindSpeed");

        case "rain_rate":
          return this.checkChartType(chartCode, "BarChart");
        case "rain_rate_raw":
          return this.checkChartType(chartCode, "BarChart");
        case "rainfalls":
          return this.checkChartType(chartCode, "BarChart");
        case "rainfalls_1h":
          return this.checkChartType(chartCode, "BarChart");
        case "rainfalls_3h":
          return this.checkChartType(chartCode, "BarChart");

        case "water_depth":
          return this.checkChartType(chartCode, "BarChart");

        case "solar_radiation":
          return this.checkChartType(chartCode, "LineChart");
        case "solar_lux":
          return this.checkChartType(chartCode, "LineChart");
        case "solar_par":
          return this.checkChartType(chartCode, "LineChart");
        case "uvi":
          return this.checkChartType(chartCode, "LineChart");
        case "dew_point":
          return this.checkChartType(chartCode, "LineChart");

        case "soil_temperature":
          return this.checkChartType(chartCode, "LineChart");
        case "soil_moisture":
          return this.checkChartType(chartCode, "LineChart");
        case "soil_conductivity":
          return this.checkChartType(chartCode, "LineChart");
        case "soil_conductivity_pore":
          return this.checkChartType(chartCode, "LineChart"); // MuRaTa
        case "soil_ph":
          return this.checkChartType(chartCode, "LineChart");

        case "battery_percentage":
          return this.checkChartType(chartCode, "LineChart");
        case "bug_num":
          return this.checkChartType(chartCode, "LineChart");
        case "voltage":
          return this.checkChartType(chartCode, "LineChart");
        case "solar_voltage":
          return this.checkChartType(chartCode, "LineChart");

        // admin
        case "rssi":
          return this.checkChartType(chartCode, "LineChart");
        case "snr":
          return this.checkChartType(chartCode, "LineChart");
        case "voltage_to_battery_percentage":
          return this.checkChartType(chartCode, "LineChart");
        case "inner_temperature":
          return this.checkChartType(chartCode, "LineChart");
        case "rssi_to_signal_bar":
          return this.checkChartType(chartCode, "BarChart");
        case "lqi_to_signal_bar":
          return this.checkChartType(chartCode, "BarChart");

        // 黑名單不畫圖
        case "wind_direction":
          return false;

        // 預設都畫線圖
        default:
          return this.checkChartType(chartCode, "LineChart"); //return false
      }
    },
    /**
     * renderColumn 用來設定該感測器參數要佔的 col 大小
     * @param {string} sesorItem - 感測器參數代碼
     * @param {string} blockSize - 用來取得 sm, md, lg, xl 的尺寸
     */
    renderColumn(sensorItem, blockSize) {
      switch (sensorItem) {
        case "wind_speed":
          if (this.device.hashid[0].toLowerCase() == "w")
            return this.sizeColumn["big"][blockSize];
          else return this.sizeColumn["default"][blockSize];
        default:
          return this.sizeColumn["default"][blockSize];
      }
    },
  },
  beforeDestroy() {
    // Cancel Auto Update
    if (this.autoUpdate) {
      clearInterval(this.timer);
    }
  },
};
</script>


<style lang="scss" scoped>
.device-hashid {
  font-size: 0.8rem;
  margin-left: 8px;
}
.device-deviceid {
  font-size: 0.75rem;
  margin-left: 5px;
}
.device-chart-block {
  margin-top: 5px;
  margin-bottom: 20px;
  padding: 10px 0px;
}
.device-chart-title {
  margin-bottom: 5px;
  .device-name {
    display: inline-block;
    margin-right: 20px;
    i {
      color: #cea212;
    }
  }
  .cropperiod-info {
    //display: inline-block;
    margin-left: 25px;
    margin-bottom: -10px;
    margin-right: 20px;
    color: #747974;
  }
  .update-time {
    display: inline-block;
    margin-right: 20px;
    color: #368a3b;
    i {
      color: #9ec7a1;
    }
  }
  .admin-info {
    display: inline-block;
    margin-left: 20px;
    margin-right: 20px;
    color: #e14b4b;
    i {
      color: #c97676;
    }
  }
  .query-range {
    display: inline-block;
    margin-right: 20px;
    color: #368a3b;

    button {
      padding: 3px 10px;
      &:hover {
        color: #c4f386;
      }
    }
  }
}
.device-chart-info {
  display: inline-block;
  margin-right: 15px;
}
.device-chart-description {
  display: inline-block;
  margin-left: 30px;
}
.device-chart-list {
  margin: 10px 0px 10px 0px;
  padding: 5px 2px 5px 10px;
  border: 1px solid #a3b985;
  border-radius: 5px;

  @media (max-width: 320px) {
    padding-left: 5px;
  }
}
.device-chart-col {
  margin-top: 10px;
  margin-bottom: 25px;
  padding: 0;
}
</style>
